import { render, staticRenderFns } from "./examine-logistics.vue?vue&type=template&id=98801d4e&scoped=true"
import script from "./examine-logistics.vue?vue&type=script&lang=js"
export * from "./examine-logistics.vue?vue&type=script&lang=js"
import style0 from "./examine-logistics.vue?vue&type=style&index=0&id=98801d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98801d4e",
  null
  
)

export default component.exports